import React, { Component } from 'react';

class InfoOrderRestaurant extends Component {


}

export default InfoOrderRestaurant;